export default __webpack_public_path__ + "static/media/paper19.a54d9cf4.JPG";